import { TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import DialogModal from "../../../elements/dialogModal/DialogModal";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import TwoFa from "../../../elements/twoFa/TwoFa";
import { StyledSwitchWrapper } from "../../../masterBalances/styledMasterBalances";

import DefaultButton from "../../../styles/materialButtonStyle";
import MaterialCheckbox from "../../../styles/materialCheckbox";
import MaterialSwitch from "../../../styles/materialSwitch";
import { StyledApplyToItem, StyledApplyToWrapper } from "../../../styles/styledApplyTo";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";
import { StyledCheckbox, StyledFormGrid } from "../../../styles/styledTabsForm";

const ExchangeUserPairsList = ({ userPairs, notification, setNotification, fetchUserPairs }) => {
  const { t } = useTranslation("exchangerPage");

  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [checked, setChecked] = useState([]);
  const [massEditingData, setMassEditingData] = useState({
    percent: 0,
    constant: 0,
    isActive: false
  });

  const inputType = {
    percent: "percent",
    constant: "constant",
    isActive: "isActive"
  };

  const [currentType, setCurrentType] = useState(null);

  const onChangeApply = (event, index) => {
    setChecked((prev) => {
      const updated = [...prev];
      updated[index] = event.target.checked;
      return updated;
    });
  };

  const handleCheckAll = (event) => {
    setChecked(userPairs.map(() => event.target.checked));
  };

  const renderApplyButton = (action) => {
    return (
      <DefaultButton color="success" onClick={action}>
        {t("userPairs.table.applyTo")} {checked?.filter(Boolean).length}/{userPairs.length}
      </DefaultButton>
    );
  };
  const changeInputValue = (event, type) => {
    setMassEditingData({ ...massEditingData, [type]: event.target.value });
  };

  const massEditing = async (event) => {
    event.preventDefault();

    const twoFa = event.target.twofa.value;

    let data = document.getElementsByName("applyTo"), res = [];

    for (let i = 0; i < data.length; i++) {
      if (data[i].checked) {
        res.push(data[i].id);
      }
    }

    axios.post("/api/user-exchanger-pairs/mass-edit", {
        data: res,
        type: currentType,
        value: massEditingData[currentType],
        twoFa
      },
      userAuthenticationConfig()
    ).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        fetchUserPairs();
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("userPairs.table.success") });
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const handleChangePairActivity = (event, userPairId) => {
    let pairChecked = event.target.checked;

    axios.put("/api/user-exchange-pairs/" + userPairId, { isActive: pairChecked }, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        fetchUserPairs();
        setNotification({
          ...notification,
          visible: true,
          type: "success",
          message: t("userPairs.details.changeForm.success")
        });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    setChecked(userPairs?.map(() => false) || []);
  }, [userPairs]);

  const renderMassEdit = () => {
    return (
      <StyledFormGrid className="apply-to-wrapper">
        <StyledApplyToWrapper col="4">
          <StyledApplyToItem>
            <TextField
              className="grid-form__input"
              variant="filled"
              label={t("userPairs.table.percent")}
              id={inputType.percent}
              type="text"
              value={massEditingData.percent}
              onChange={(event => changeInputValue(event, inputType.percent))}
            />
            {renderApplyButton(() => {
              setCurrentType(inputType.percent);
              setOpen(true);
            })}
          </StyledApplyToItem>
          <StyledApplyToItem>
            <TextField
              className="grid-form__input"
              variant="filled"
              label={t("userPairs.table.constant")}
              id={inputType.constant}
              type="text"
              value={massEditingData.constant}
              onChange={(event => changeInputValue(event, inputType.constant))}
            />
            {renderApplyButton(() => {
              setCurrentType(inputType.constant);
              setOpen(true);
            })}
          </StyledApplyToItem>
          <StyledApplyToItem>
            <StyledSwitchWrapper>
              <div>
                {t("userPairs.table.activity")}
              </div>
              <MaterialSwitch
                checked={massEditingData.isActive}
                id={inputType.isActive}
                onChange={event => setMassEditingData({
                  ...massEditingData,
                  [inputType.isActive]: event.target.checked
                })}
                label={t("userPairs.table.percent")}
                name="Pair activity"
              />
            </StyledSwitchWrapper>
            {renderApplyButton(() => {
              setCurrentType(inputType.isActive);
              setOpen(true);
            })}
          </StyledApplyToItem>
        </StyledApplyToWrapper>
      </StyledFormGrid>
    );
  };

  if (!userPairs) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (userPairs.length === 0) {
    return <Alert severity="warning">{t("userPairs.table.emptyData")}</Alert>;
  }

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title="Action confirmation"
        content={<TwoFa
          handleSubmit={massEditing}
          error={error}
        />}
      />
      {renderMassEdit()}
      <StyledScrollTable>
        <StyledTable
          width="2100"
          size="14"
          className="exchange-user-pairs"
        >
          <StyledTableHead
            scroll="auto"
            col="9"
            className="exchange-user-pairs__head"
          >
            <div>
              <StyledCheckbox position="center">
                <MaterialCheckbox
                  type="checkbox"
                  name="checkAll"
                  id="checkAll"
                  checked={checked?.length > 0 ? checked.every(Boolean) : false}
                  indeterminate={checked?.length > 0 && checked.some(Boolean) && !checked.every(Boolean)}
                  onChange={handleCheckAll}
                />
              </StyledCheckbox>
            </div>
            <div>
              {t("userPairs.table.activity")}
            </div>
            <div>
              {t("userPairs.table.client")}
            </div>
            <div>
              {t("userPairs.table.give")}
            </div>
            <div>
              {t("userPairs.table.receive")}
            </div>
            <div>
              {t("userPairs.table.percent")}
            </div>
            <div>
              {t("userPairs.table.constant")}
            </div>
            <div>
              {t("userPairs.table.rate")}
            </div>
            <div />
          </StyledTableHead>
          <StyledTableBody>
            {userPairs && userPairs.map((value, index) => (
              <StyledTableRow
                key={index}
                scroll="auto"
                col="9"
                className="exchange-user-pairs__row"
              >
                <StyledCol>
                  <StyledCheckbox position="center">
                    <MaterialCheckbox
                      type="checkbox"
                      name="applyTo"
                      id={value.id}
                      checked={checked?.[index] || false}
                      onChange={(event) => onChangeApply(event, index)}
                    />
                  </StyledCheckbox>
                </StyledCol>
                <StyledCol>
                  <MaterialSwitch
                    checked={value.isActive}
                    onChange={event => handleChangePairActivity(event, value.id)}
                    name="Pair activity"
                  />
                </StyledCol>
                <StyledCol inline>
                  <StyledBreakWord>
                    {value.user.nickname ? value.user.nickname + ":" : ""} {value.user.email}
                  </StyledBreakWord>
                </StyledCol>
                <StyledCol>
                  {getServiceNameWithNickname(value.exchangePair.inService.name, value.exchangePair.inService.nickname)} {value.exchangePair.inCurrency.asset}
                </StyledCol>
                <StyledCol>
                  {getServiceNameWithNickname(value.exchangePair.outService.name, value.exchangePair.outService.nickname)} {value.exchangePair.outCurrency.asset}
                </StyledCol>
                <StyledCol>
                  {Math.round((value.percent * 100) * 1000) / 1000} %
                </StyledCol>
                <StyledCol>
                  {value.constant}
                </StyledCol>
                <StyledCol>
                  {value?.rate}
                </StyledCol>
                <StyledCol inline>
                  <NavLink
                    className="table-action table-action_info"
                    to={"/exchange/user-pairs/" + value.id}
                  >
                    <span className="icon-light-edit"/>
                    {t("userPairs.table.edit")}
                  </NavLink>
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};

export default ExchangeUserPairsList;